export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de procesos"])},
          "estimated_harvests_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cosechas"])},
          "estimated_containers_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contenedores"])},
          "schedule_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Programación"])},
          "total_number_estimated_harvests": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cosechas estimadas"])},
          "total_number_estimated_containers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contenedores estimados"])}
        }
      }
    }
  })
}